const config = {
  GOOGLE: {
    CLIENT_ID:
      "802912502462-ujohisjgkq3sb55sk130mbnhrcnks4f4.apps.googleusercontent.com",
  },
};

export default config;
